export const REDUCER_KEY_RS_EXPORT = 'rsExport';

export const SHOW_EXPORT_DIALOG = 'rs/SHOW_EXPORT_DIALOG';
export const HIDE_EXPORT_DIALOG = 'rs/HIDE_EXPORT_DIALOG';
export const FETCH_EXPORT_OPTIONS = 'rs/FETCH_EXPORT_OPTIONS';
export const FETCH_EXPORT_OPTIONS_SUCCESS = 'rs/FETCH_EXPORT_OPTIONS_SUCCESS';
export const FETCH_EXPORT_OPTIONS_FAILURE = 'rs/FETCH_EXPORT_OPTIONS_FAILURE';

export const EXPORT_CLEAR_STATE = 'rs/EXPORT_CLEAR_STATE';